module.exports = __webpack_public_path__ + "img/second-1-opened.9c9321f1.webp";